import { useCallback, useEffect, useState } from 'react';

const KEY = 't212:pinned';

function read(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as string[];
  } catch {
    return [];
  }
}

function write(arr: string[]) {
  localStorage.setItem(KEY, JSON.stringify(arr));
  // Notify other hook instances in the same tab.
  window.dispatchEvent(new Event('t212:pinned-changed'));
}

export function usePinnedTickers() {
  const [pinned, setPinned] = useState<string[]>(() => read());

  useEffect(() => {
    const onChange = () => setPinned(read());
    window.addEventListener('storage', onChange);
    window.addEventListener('t212:pinned-changed', onChange);
    return () => {
      window.removeEventListener('storage', onChange);
      window.removeEventListener('t212:pinned-changed', onChange);
    };
  }, []);

  const toggle = useCallback((ticker: string) => {
    const cur = read();
    const next = cur.includes(ticker) ? cur.filter((t) => t !== ticker) : [...cur, ticker];
    write(next);
    setPinned(next);
  }, []);

  const isPinned = useCallback(
    (ticker: string) => pinned.includes(ticker),
    [pinned],
  );

  return { pinned, toggle, isPinned };
}
